// extracted by mini-css-extract-plugin
export default {"roles":"RolesSettings_roles__YVBo7","header":"RolesSettings_header__FZNix"};